export const LOGOUT_USER = 'LOGOUT_USER';
export const SET_MODALS = 'SET_MODALS';